<mat-card>
  <mat-card-content>
    <mat-card-header *ngIf="!widget.meta.hideTitle">
      <mat-card-title
        *ngIf="!changeTitle; else editTitleWidget"
        [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
        matTooltipPosition="above"
        (dblclick)="editTitle()"
        class="editTitle"
        >{{ widget.name }}
        <sn-icon size="xs">edit</sn-icon>
      </mat-card-title>
      <button
        mat-icon-button
        icon="create"
        color="accent"
        [matTooltip]="'dashboard.operational.widgets.editCode' | t"
        matTooltipPosition="before"
        (click)="editCode = true"
        *ngIf="!editCode"
      >
        <mat-icon>create</mat-icon>
      </button>
      <button
        mat-icon-button
        icon="cancel"
        color="warn"
        [matTooltip]="'dashboard.operational.widgets.cancelEditCode' | t"
        matTooltipPosition="before"
        (click)="editCode = false"
        *ngIf="editCode"
      >
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-card-header>
    <ng-container *ngIf="!widget.meta.embedCode || editCode">
      <form [formGroup]="form" (ngSubmit)="submitForm()" class="code-form">
        <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
        <div class="fs-text-right">
          <button mat-button color="success" type="submit" [disabled]="form.invalid">{{ 'common.send' | t }}</button>
          <button
            mat-button
            *ngIf="widget.meta.embedCode"
            color="danger"
            type="button"
            (click)="editCode = false"
          >
            {{ 'common.cancel' | t }}
          </button>
        </div>
      </form>
    </ng-container>
    <ng-container *ngIf="clearCode && !editCode">
      <div [innerHTML]="clearCode"></div>
    </ng-container>
  </mat-card-content>
</mat-card>
<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
